(function(){
    'use strict';

    angular
       .module('appback')
       .factory('NominasService', NominasService);

   NominasService.$inject = ['$http'];

   function NominasService($http){


       var service= {
           saveNomina: saveNomina
       };

       return service;

       function saveNomina(nomina)
       {
           var config = {
               headers : {
                   'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
               }
           }

           var data = $.param({
            fileName: nomina.nombre_generado,
            filePath: nomina.ruta,
           });
           return $http.post('/backend/nominas/savenomina', data, config)
       }

   }
})();